import React from 'react';
import { renderToString } from 'react-dom/server';
import BellIcon from '../../components/icons/BellIcon';
import ExternalIcon from '../../components/icons/ExternalIcon';
import TruckIcon from '../../components/icons/TruckIcon';
import BowlIcon from '../../components/icons/categories/static/Bowls';
import BreakfastIcon from '../../components/icons/categories/static/Breakfast';
import ChipsAndGuacIcon from '../../components/icons/ChipsAndGuacIcon';
import ClockIcon from '../../components/icons/ClockIcon';
import CouponIcon from '../../components/icons/CouponIcon';
import DeliveryBoxEmptyIcon from '../../components/icons/DeliveryBoxEmptyIcon';
import DeliveryBoxFullIcon from '../../components/icons/DeliveryBoxFullIcon';
import DeliveryBoxNotFullIcon from '../../components/icons/DeliveryBoxNotFullIcon';
import DrinkIcon from '../../components/icons/categories/static/Drinks';
import EditIcon from '../../components/icons/EditIcon';
import FAQIcon from '../../components/icons/FAQIcon';
import FavoriteIcon from '../../components/icons/FavoriteIcon';
import JarIcon from '../../components/icons/JarIcon';
import GreensIcon from '../../components/icons/GreensIcon';
import LightbulbIcon from '../../components/icons/LightbulbIcon';
import LoyaltyIcon from '../../components/icons/LoyaltyIcon';
import MailIcon from '../../components/icons/MailIcon';
import PhoneIcon from '../../components/icons/PhoneIcon';
import ProteinIcon from '../../components/icons/categories/static/Proteins';
import RatingThumbsDownIcon from '../../components/icons/RatingThumbsDownIcon';
import RatingThumbsUpIcon from '../../components/icons/RatingThumbsUpIcon';
import RecentOrdersIcon from '../../components/icons/RecentOrdersIcon';
import ReferAFriendIcon from '../../components/icons/ReferAFriendIcon';
import ReviewIcon from '../../components/icons/ReviewIcon';
import SaladIcon from '../../components/icons/categories/static/Salads';
import SandwichIcon from '../../components/icons/categories/static/Sandwiches';
import ScheduledOrderCancelIcon from '../../components/icons/ScheduledOrderCancelIcon';
import ScheduledOrderIcon from '../../components/icons/ScheduledOrderIcon';
import ScheduledOrderModifyIcon from '../../components/icons/ScheduledOrderModifyIcon';
import SkipOrderIcon from '../../components/icons/SkipOrderIcon';
import SnackIcon from '../../components/icons/categories/static/Snacks';
import StarIcon from '../../components/icons/StarIcon';
import SubstituteIcon from '../../components/icons/SubstituteIcon';
import WrapsIcon from '../../components/icons/categories/static/Wraps';
import FacebookIcon from '../../components/icons/social/Facebook';
import InstagramIcon from '../../components/icons/social/Instagram';
import TikTokIcon from '../../components/icons/social/TikTok';
import TwitterIcon from '../../components/icons/social/Twitter';

/** @type {Object<string, (className?: string) => React.ReactElement>} */
export const iconMap = {
  Bell: className => <BellIcon className={className} />,
  'External Link': className => <ExternalIcon className={className} />,
  Truck: className => <TruckIcon className={className} />,
  Bowl: className => <BowlIcon className={className} />,
  Breakfast: className => <BreakfastIcon className={className} />,
  'Chips and Guacamole': className => (
    <ChipsAndGuacIcon className={className} />
  ),
  Clock: className => <ClockIcon className={className} />,
  Coupon: className => <CouponIcon className={className} />,
  'Empty Box': className => <DeliveryBoxEmptyIcon className={className} />,
  'Full Box': className => <DeliveryBoxFullIcon className={className} />,
  'Not Full Box': className => <DeliveryBoxNotFullIcon className={className} />,
  Drink: className => <DrinkIcon className={className} />,
  Edit: className => <EditIcon className={className} />,
  FAQ: className => <FAQIcon className={className} />,
  Favorite: className => <FavoriteIcon className={className} />,
  Jar: className => <JarIcon className={className} />,
  Greens: className => <GreensIcon className={className} />,
  Lightbulb: className => <LightbulbIcon className={className} />,
  Loyalty: className => <LoyaltyIcon className={className} />,
  Mail: className => <MailIcon className={className} />,
  Phone: className => <PhoneIcon className={className} />,
  Protein: className => <ProteinIcon className={className} />,
  'Thumbs Down': className => <RatingThumbsDownIcon className={className} />,
  'Thumbs Up': className => <RatingThumbsUpIcon className={className} />,
  'Recent Orders': className => <RecentOrdersIcon className={className} />,
  'Refer A Friend': className => <ReferAFriendIcon className={className} />,
  Review: className => <ReviewIcon className={className} />,
  Salad: className => <SaladIcon className={className} />,
  Sandwich: className => <SandwichIcon className={className} />,
  'Cancel Scheduled Order': className => (
    <ScheduledOrderCancelIcon className={className} />
  ),
  'Scheduled Order': className => <ScheduledOrderIcon className={className} />,
  'Modify Scheduled Order': className => (
    <ScheduledOrderModifyIcon className={className} />
  ),
  'Skip Order': className => <SkipOrderIcon className={className} />,
  Snack: className => <SnackIcon className={className} />,
  Star: className => <StarIcon className={className} />,
  Substitution: className => <SubstituteIcon className={className} />,
  Wraps: className => <WrapsIcon className={className} />,
  Facebook: className => <FacebookIcon className={className} />,
  Instagram: className => <InstagramIcon className={className} />,
  TikTok: className => <TikTokIcon className={className} />,
  Twitter: className => <TwitterIcon className={className} />,
};

/**
 * @param {string|undefined} iconName
 * @param {string=} className
 */
export function getIcon(iconName, className) {
  const iconComponent = iconName ? iconMap[iconName] : null;

  if (!iconComponent) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }
  return iconComponent(className);
}

/**
 * @param {string|undefined} iconName
 * @param {string=} className
 */
export function renderIconString(iconName, className) {
  return renderToString(getIcon(iconName, className));
}
